import React, { useEffect, useState } from 'react';
import { Box, Container } from '@mui/material';

import { SearchByOptions, LeaveYourRequirement, BreadcrumbBar, AdBannerVertical } from '..';

import { HeaderSection } from './HeaderSection';
import { formatDistance, getWithLocale } from '../../utils/utils';
import { useDetail } from '../../pages_handler/listPage/client-side/DetailContext';
import { GalleryView } from '../galleryView';
import { DetailMenuSection } from './DetailMenuSection';
// import { SubcateLinks } from '../SubcateLinks';

export const DetailPageLayout = ({
  action,
  t,
  breadcrumb,
  isMobileFilterOpen,
  onMobileSearchOk,
  onMobileSearchClose,
  header,
  ownerInfo,
  detail,
  provinceTable,
  actionsTable,
  categoryTable,
  locationTypeTable,
  data,
  actionCateLocationType,
  onSellerInfoChanged,
  loading,
  nearbyList,
  locale,
  categoryId,
  actionId,
}) => {
  const [nearbyLocation, setNearbyLocation] = useState<{
    distance: string;
    location: string;
  }>({ distance: '', location: '' });

  const { sectionList, sectionRefs } = useDetail();
  const [activeKey, setActiveKey] = useState(() => sectionList?.[0]?.key || '');
  const isProject = action === t('project');

  const handleMenuClick = (key) => {
    setActiveKey(key);
    sectionRefs.current[key]?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  useEffect(() => {
    if (!nearbyList?.length || !locale) return;

    const item = nearbyList?.find((i) => i?.children?.props?.data?.[0]);
    if (!item) {
      setNearbyLocation({ distance: '', location: '' });
      return;
    }

    const data = item.children.props.data[0];
    setNearbyLocation({
      distance: formatDistance(Number(data?.distance), locale),
      location: `${getWithLocale(data, 'Name', locale)} ${getWithLocale(data, 'branch_Name', locale)}`,
    });
  }, [nearbyList, locale]);

  return (
    <Box sx={{ bgcolor: '#F5F5F6', minHeight: '100vh' }}>
      {/* Top Bar Section */}
      <Box sx={{ bgcolor: '#FFF' }}>
        <Container maxWidth="xl">
          <Box py={2}>
            <SearchByOptions
              nologo
              searchbgClass={{ width: '100%' }}
              isMobileFilterOpen={isMobileFilterOpen}
              onMobileSearchOk={onMobileSearchOk}
              onMobileSearchClose={onMobileSearchClose}
              provinceTable={provinceTable}
              locationTypeTable={locationTypeTable}
              actionsTable={actionsTable}
              categoryTable={categoryTable}
              pathIds={{
                action_id: null,
                cateogry_ID: null,
                province_id: null,
                amphur_id: null,
                distinct_id: null,
                location_type_id: null,
                location_id: null,
                location_branch_id: null,
              }}
              actionCateLocationType={actionCateLocationType}
              loading={loading}
            />
          </Box>
          <Box py={2}>
            <BreadcrumbBar breadcrumb={breadcrumb} locale={locale} t={t} />
          </Box>
        </Container>
      </Box>

      {/* Main Content */}
      <Box sx={{ mt: 7, pb: 5, bgcolor: '#F5F5F6' }}>
        <Container maxWidth="xl">
          {/* Gallery + Header */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              bgcolor: '#FFF',
              borderRadius: '20px',
              mb: 2,
              gap: 2,
            }}
          >
            <GalleryView t={t} images={data?.images} projectId={data?.project_ID} propertyId={data?.property_ID} />
            <Box p={1} py={2}>
              <HeaderSection header={header} nearbyLocation={nearbyLocation} isProject={isProject} detail={data} />
            </Box>
          </Box>

          <Box display={'flex'} justifyContent={'space-between'}>
            <Box flex="1 1 0" minWidth={0}>
              {/* Menu Detail */}
              <Box
                sx={{
                  bgcolor: '#FFF',
                  borderRadius: '20px',
                  px: 2,
                  py: 0.5,
                }}
              >
                <DetailMenuSection sectionList={sectionList} activeKey={activeKey} onMenuClick={handleMenuClick} />
              </Box>

              {/* Main Detail */}
              <Box
                sx={{
                  bgcolor: '#FFF',
                  borderRadius: '20px',
                  px: 3,
                  py: 2,
                  mt: 2,
                }}
              >
                {{ ...detail, sectionRefs: sectionRefs }}
              </Box>
            </Box>

            {/* Sidebar (Desktop only) */}
            <Box
              sx={{
                display: { xs: 'none', lg: 'flex' },
                flexDirection: 'column',
                gap: 3,
                width: 348,
                ml: 2,
              }}
            >
              <LeaveYourRequirement t={t} />

              {/* <Box bgcolor='#fff' p={2} borderRadius='10px'>
                <SubcateLinks
                  t={t}
                  actionid={actionId}
                  categoryid={categoryId}
                  locale={locale}
                  showListPathIds={''}
                  searchParamsList={{}}
                />
              </Box> */}
              <AdBannerVertical adSlot="9031826647" style={{ width: '100%', paddingTop: '10px' }} />
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};
